module.exports = __webpack_public_path__ + "img/icon (21).4702731a.png";